import type { DataFile, Flag } from './types';

export function parseFlags(datafile: DataFile) {
    return datafile.featureFlags.reduce(
        (acc, flag) => {
            const variable = flag.variables[0];
            if (!variable) return acc;

            const options = new Set<string>();
            options.add(variable.defaultValue);

            flag.experimentIds.forEach(id => {
                datafile.experiments
                    .find(exp => exp.id === id)
                    ?.variations.forEach(variation => {
                        variation.variables.forEach(v => {
                            if (v.id === variable.id) options.add(v.value);
                        });
                    });
            });

            datafile.rollouts
                .find(r => r.id === flag.rolloutId)
                ?.experiments.forEach(exp => {
                    exp.variations.forEach(variation => {
                        variation.variables.forEach(v => {
                            if (v.id === variable.id) options.add(v.value);
                        });
                    });
                });

            acc[flag.key] = {
                id: flag.id,
                key: flag.key,
                isAbTest: flag.experimentIds.length > 0,
                options: Array.from(options),
                category: getCategory(flag.key),
            };

            return acc;
        },
        {} as Record<string, Flag>
    );
}

function getCategory(flag: string) {
    if (flag.startsWith('ff_')) return 'ff';
    if (flag.startsWith('exp_')) return 'ab';
    return 'control';
}
